import { render, staticRenderFns } from "./AddEventRolesDialog.vue?vue&type=template&id=672d547c&"
import script from "./AddEventRolesDialog.vue?vue&type=script&lang=js&"
export * from "./AddEventRolesDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEventRolesDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports